import { Box, HStack, Switch, Text } from "@chakra-ui/react";
import React, { useMemo, useRef } from "react";

// Enhanced, compact toggle with label and optional icon
export default function CustomSwitch({ children, icon, className, ...switchProps }: any) {
  const switchRef = useRef<HTMLInputElement | null>(null);

  // Chakra Switch is controlled by isChecked or defaultChecked. Use for styling.
  const isChecked = Boolean((switchProps as any)?.isChecked);

  const containerStyles = useMemo(
    () => ({
      bg: isChecked ? "var(--accent)" : "transparent",
      color: isChecked ? "var(--white)" : "var(--white)",
      border: isChecked ? "1px solid var(--accent)" : "1px solid var(--gray)",
    }),
    [isChecked]
  );

  return (
    <HStack
      className={className}
      spacing={2}
      px={3}
      py={1}
      borderRadius="md"
      cursor="pointer"
      userSelect="none"
      transition="all 0.15s ease"
      _hover={{ borderColor: "var(--accent)" }}
      {...containerStyles}
      onClick={(e) => {
        // Avoid double toggle if the actual switch is clicked
        const target = e.target as HTMLElement;
        if (target.closest("[data-custom-switch-root='true']")) return;
        switchRef.current?.click();
      }}
    >
      {icon ? <Box display="flex" alignItems="center">{icon}</Box> : null}
      {children ? (
        <Text
          fontSize="13px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxW={{ base: "140px", md: "200px" }}
        >
          {children}
        </Text>
      ) : null}
      <Box data-custom-switch-root="true" onClick={(e) => e.stopPropagation()}>
        <Switch ref={switchRef as any} size="sm" colorScheme="yellow" {...switchProps} />
      </Box>
    </HStack>
  );
}
